import styled from "styled-components";

import { StyledPanelWrapper } from "@/components/templates/DetailsPage/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledPdfReader = styled.div`
    height: 900px;
    margin-top: 16px;
    border-radius: var(--radius-10);
    @media ${breakpoints.xs} {
        height: 450px;
    }
`;

export const StyledInvoiceDetailsPage = styled.div`
    ${StyledPanelWrapper} {
        margin-bottom: 0;
    }
`;
